import apiClient from './client';
import {
    CascadeBlocksListResponse,
    CascadeBlocksSummaryResponse,
    CascadeDefaultSteps,
    GenerateCascadeBlocksRequest,
    GenerateCascadeBlocksResponse,
    RevampCascadeBlocksRequest,
    RevampCascadeBlocksResponse,
} from '@/types/cascade-blocks';

// ========== CASCADE BLOCKS API ==========

// Steps default de cascade por tipo de bloco
export const getCascadeDefaultSteps = async (): Promise<CascadeDefaultSteps> => {
    const response = await apiClient.get<CascadeDefaultSteps>('/cascade-blocks/steps');
    return response.data;
};

// Gerar blocos de cascade
export const generateCascadeBlocks = async (
    data: GenerateCascadeBlocksRequest
): Promise<GenerateCascadeBlocksResponse> => {
    const response = await apiClient.post<GenerateCascadeBlocksResponse>(
        '/cascade-blocks/generate',
        data
    );
    return response.data;
};

// Revamp de blocos cascade (arquivar + recriar)
export const revampCascadeBlocks = async (
    data: RevampCascadeBlocksRequest
): Promise<RevampCascadeBlocksResponse> => {
    const response = await apiClient.post<RevampCascadeBlocksResponse>(
        '/cascade-blocks/revamp',
        data
    );
    return response.data;
};

// Listar blocos cascade de um domínio
export const getCascadeBlocks = async (
    domainId: number,
    blockType?: string,
    formatType?: string,
    includeArchived: boolean = false
): Promise<CascadeBlocksListResponse> => {
    const params = new URLSearchParams();
    if (blockType) params.append('block_type', blockType);
    if (formatType) params.append('format_type', formatType);
    if (includeArchived) params.append('include_archived', 'true');

    const response = await apiClient.get<CascadeBlocksListResponse>(
        `/cascade-blocks/domain/${domainId}?${params.toString()}`
    );
    return response.data;
};

// Resumo de cascade blocks de um domínio
export const getCascadeBlocksSummary = async (
    domainId: number
): Promise<CascadeBlocksSummaryResponse> => {
    const response = await apiClient.get<CascadeBlocksSummaryResponse>(
        `/cascade-blocks/domain/${domainId}/summary`
    );
    return response.data;
};
